import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'What is a joyagoo coupon code and how do I use it?',
    a: 'A joyagoo coupon code is a discount code you enter at checkout on repsw2c.com to save money on your order. Simply copy the code from our site, add items to your cart, and paste the code in the promo code field before completing your purchase. Check our latest joyagoo coupon code page for verified working codes.',
  },
  {
    q: 'Are joyagoo coupon codes free to use?',
    a: 'Yes, all joyagoo coupon codes listed on joyagoocoupon.net are completely free to use. We collect and verify codes from various sources so you can save without any cost. Simply copy and apply at checkout.',
  },
  {
    q: 'How often are new joyagoo promo codes added?',
    a: 'We update our joyagoo promo codes daily. New seasonal deals, flash sales, and exclusive discounts are added regularly. Bookmark this page and check back often to never miss a deal.',
  },
  {
    q: 'What is the joyagoo spreadsheet and how does it help?',
    a: 'The joyagoo spreadsheet is a community-maintained product catalog that helps buyers find specific items, compare prices, and discover the best deals. Our joyagoo spreadsheet guide explains how to use it effectively to find exactly what you\'re looking for.',
  },
  {
    q: 'How long does joyagoo shipping take to the USA?',
    a: 'Joyagoo shipping to the USA typically takes 7-15 business days depending on the shipping method chosen. Express shipping options are available for faster delivery. Read our full joyagoo shipping guide for detailed information on all shipping methods and costs.',
  },
  {
    q: 'Is joyagoo legit and safe to buy from?',
    a: 'Yes, joyagoo (repsw2c.com) is a legitimate online fashion store with thousands of satisfied customers worldwide. The platform offers buyer protection, quality control photos, and responsive customer service. Read our detailed joyagoo review for an honest assessment.',
  },
  {
    q: 'Can I get free shipping with a joyagoo coupon?',
    a: 'Yes! We regularly feature joyagoo free shipping codes and shipping coupons. Orders over $50 often qualify for free shipping automatically. Check our joyagoo shipping coupon page for the latest free shipping deals.',
  },
  {
    q: 'What products can I buy with joyagoo coupons?',
    a: 'Joyagoo coupons work across all product categories including shoes, hoodies, t-shirts, jackets, pants, jerseys, accessories, and more. Most coupon codes apply site-wide, though some may be category-specific.',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Frequently Asked Questions</h2>
          <p className="text-gray-500 text-base">Everything you need to know about joyagoo coupons and shopping</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 text-sm md:text-base pr-4">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                  <i className={`text-orange-500 text-lg transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Check our detailed guides.</p>
          <Link
            to="/how-to-use-joyagoo"
            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            How to Use Joyagoo Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
